import jwtDecode from "jwt-decode"

function decodeToken(token) {
	return jwtDecode(token)
}

export default decodeToken
